import {
  Frame,
  SkeletonPage,
  Layout,
  SkeletonBodyText,
  LegacyStack,
} from '@shopify/polaris';

function LoadingCom() {
  return (
    <div>
      <SkeletonPage primaryAction>
        <Layout>
          <Frame>
            <LegacyStack vertical>
              <SkeletonBodyText lines={5} />
            </LegacyStack>
          </Frame>
        </Layout>
      </SkeletonPage>
    </div>
  );
}

export default LoadingCom;
